export const CHILD = 1
export const PARENT = 2
export const SUCCESSOR = 3
export const PREDECESSOR = 4
